import React from 'react'
import styled, { css } from 'styled-components'
import { responsive } from '../../utils/responsive'

const Root = styled.div`
  width: 100%;
  ${(p) => responsive('padding', p.$padding || p.theme.layout?.page?.padding || '24px', p.theme)}
  ${(p) => responsive('max-width', p.$maxWidth || p.theme.layout?.page?.maxWidth || '1800px', p.theme)}
  margin: 0 auto;
`

export function Page({ children, padding, maxWidth, ...props }) {
  return (
    <Root $padding={padding} $maxWidth={maxWidth} {...props}>
      {children}
    </Root>
  )
}
